import axios from 'axios';
import { logout } from '../redux/auth/saga';
import { SERVER_ADDRESS } from '../settings';
import SuperFetch from './superFetch';

class AuthHelper {
   login = async userInfo => {
      var resp = null;
      if (!userInfo.username || !userInfo.password) {
         return { error: "¡El nombre de usuario y la contraseña son obligatorios!" };
      }

      await SuperFetch.post('/api/token', userInfo).then(response => {
         if (response.access_token == undefined) {
            response = { error: "¡Verifique las credenciales dadas!" };
         }

         if (response.access_token != undefined) {
            this.obtainTicketCredentials(response.access_token);
            let currDate = new Date();
            let expireDate = new Date(currDate.setMinutes(currDate.getMinutes() + response.expires_in));
            localStorage.setItem("tokenExpiresAt", expireDate.toString());
            localStorage.setItem("firstAccess", response.firstAccess);
         }


         resp = response;
      }).catch(exc => { });

      return resp;
   };

   checkExpirity = (token) => {
      let expireDate = new Date(localStorage.getItem("tokenExpiresAt"));
      let currDate = new Date();
      if (currDate >= expireDate) {
         return
      }

      return { token };
   };

   async checkDemoPage(token) {

      const error = this.checkExpirity(token).error;

      if (error)
         return { error: error };

      return await axios.get(`${SERVER_ADDRESS}/api/Example/IsTokenValid`,
         {
            headers: {
               Authorization: `Bearer ${token}`
            }
         })
         .then(response => {
            return ({
               status: response.statusText,
               message: response.status === 200 ? response.data : "An error message!"
            });
         })
         .catch(error => ({ error: error }))
   };

   obtainTicketCredentials = async (access_token) => {
      return await axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetUserTicketCredentials`,
         {
            headers: {
               Authorization: `Bearer ${access_token}`
            },
         }
      )
         .then(data => {
            localStorage.setItem('ticketCredentials', JSON.stringify(data.data));
         });
   };
}

export default new AuthHelper();